//#region src/integrations/xai/xaiTypes.ts
const XAI_INTEGRATION_ID = "xai";
const XAI_DEFAULT_BASE_URL = "https://api.x.ai/anthropic";
const XAI_DEFAULT_API_BASE_URL = "https://api.x.ai";
const XAI_LOGO_DARK_URL = "/logos/xai/grok_dark.svg";
const XAI_LOGO_LIGHT_URL = "/logos/xai/grok_light.svg";

//#endregion
export { XAI_DEFAULT_API_BASE_URL, XAI_DEFAULT_BASE_URL, XAI_INTEGRATION_ID, XAI_LOGO_DARK_URL, XAI_LOGO_LIGHT_URL };
//# sourceMappingURL=xaiTypes.js.map